import React, { Component } from "react";
import QuickTeamRegister from "../../popup/QuickTeamRegister";
import TeamInviteModal from "../../popup/TeamInviteModal";
// Images

// icons
import MatchesApis from "../../../helper/matches.api";
import InviteApis from "../../../helper/invite.api";

import stages from "../../../images/icon/stages.png";
import DuelsSingleEliminationMatches from "./matches/brackets/duel/DuelsSingleEliminationMatches";
import DuelsDoubleEliminationMatches from "./matches/brackets/duel/DuelsDoubleEliminationMatches";
import DuelsRoundRobinMatches from "./matches/brackets/duel/DuelsRoundRobinMatches";
import DuelsSingleBracketGroups from "./matches/brackets/duel/DuelsSingleBracketGroups";
import DuelsDoubleBracketGroups from "./matches/brackets/duel/DuelsDoubleBracketGroups";
import FFASingleEliminationMatches from "./matches/brackets/ffa/FFASingleEliminationMatches";
import FFASimpleStageMatches from "./matches/brackets/ffa/FFASimpleStageMatches";
import FFABracketGroupMatches from "./matches/brackets/ffa/FFABracketGroupMatches";
import FFAFlexibleStageMatches from "./matches/brackets/ffa/FFAFlexibleStageMatches";
import Scoreboard from "./Scoreboard";
import { Modal } from "react-bootstrap";

export default class StageMatches extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectMatch: true,
      tournamentDetails: this.props?.tournamentDetails ? this.props.tournamentDetails : null,
      stageIndex: this.props?.stageIndex ? this.props.stageIndex : null,
      tournamentId: this.props?.tournamentId ? this.props.tournamentId : null,
      stageDetails: this.props?.stageDetails ? this.props.stageDetails : null,
      isMatchDetailsAdded: true,
      groupIndex: 0,
      roundIndex: 1,
      selectedMatches: [],
      matchDetails: null,
      inMatchRole: "",
      showMatchDetails: false,
      openQuickTeamRegister: false,
      teamInvitationData: {
        invitationLink: "",
        teamName: "",
        teamId: "",
        clanId: "",
      },
    };
    this.MatchesApis = new MatchesApis();
    this.inviteApis = new InviteApis();
  }

  componentDidMount() {
    if (
      (this.props.stageIndex || this.props.stageIndex === 0) &&
      this.props.tournamentId &&
      this.props.stageDetails
    ) {
      // when we get response set isMatchDetailsAdded: true
      this.setState({ stageDetails: this.props.stageDetails });
      this.getStageDetails(this.props.tournamentId, this.props.stageIndex);
    }
  }

  componentWillReceiveProps(newProps) {
    this.setState({
      tournamentDetails: newProps?.tournamentDetails
        ? newProps.tournamentDetails
        : this.state.tournamentDetails,
      stageIndex: newProps?.stageIndex ? newProps.stageIndex : this.state.stageIndex,
      tournamentId: newProps?.tournamentId ? newProps.tournamentId : this.state.tournamentId,
      //stageDetails: newProps?.stageDetails ? newProps.stageDetails : this.state.stageDetails,
    });
  }

  componentDidUpdate(previous) {
    if (previous.stageIndex !== this.props.stageIndex) {
      this.setState({ stageDetails: this.props.stageDetails });
      this.getStageDetails(this.props.tournamentId, this.props.stageIndex);
    }
  }

  getStageDetails = (tournamentId, stageIndex) => {
    this.MatchesApis.getStageDetails(tournamentId, stageIndex)
      .then(res => {
        this.props.updateLoader(false);
        let selectedMatches = res.data.result.groups[this.state.groupIndex][this.state.roundIndex];

        this.setState({ stageDetails: res.data.result, selectedMatches: selectedMatches });
      })
      .catch(err => {
        this.props.updateLoader(false);
      });
  };

  toggleQuickTeamRegister = value => {
    this.setState({
      openQuickTeamRegister: value,
    });
  };

  toggleTeamInviteModal = value => {
    this.setState({
      openTeamInviteModal: value,
    });
  };

  // New method to handle successful team creation
  handleTeamCreated = response => {
    // Close the team registration modal
    this.toggleQuickTeamRegister(false);

    // Generate team invitation link using the new API
    const teamId = response.data.result?.team._id || "";
    const clanId = response.data.result?.clan._id || "";

    const payload = {
      contextId: teamId,
      role: "players",
      type: "team",
    };

    this.inviteApis
      .getInviteWebUrl("team", payload)
      .then(res => {
        if (res?.data) {
          const invitationLink = res.data.result;

          // Set the team invitation data
          this.setState({
            teamInvitationData: {
              invitationLink: invitationLink,
              teamName: response.data.result?.team.name || "your team",
              teamId: teamId,
              clanId: clanId,
            },
            // Open the team invite modal
            openTeamInviteModal: true,
          });
        }
      })
      .catch(err => {
        console.error("Error generating invite link:", err);
      });
  };

  getMatchesStructure = () => {
    if (this.state.stageDetails) {
      if (this.state.stageDetails.type === "DUEL") {
        switch (this.state.stageDetails.subType) {
          case "Single Elimination":
            return (
              <DuelsSingleEliminationMatches
                setGetAlertMethod={this.props.setGetAlertMethod}
                index={this.props.stageIndex}
                tournamentDetails={this.state.tournamentDetails}
                stageDetails={this.state.stageDetails}
                history={this.props.history}
                alterView={this.alterView}
                showMatchDetails={this.state.showMatchDetails}
                toggleQuickTeamRegister={this.toggleQuickTeamRegister}
              />
            );

          case "Double Elimination":
            return (
              <DuelsDoubleEliminationMatches
                setGetAlertMethod={this.props.setGetAlertMethod}
                index={this.props.stageIndex}
                tournamentDetails={this.state.tournamentDetails}
                stageDetails={this.state.stageDetails}
                history={this.props.history}
                groupIndex={this.state.groupIndex}
                alterView={this.alterView}
                showMatchDetails={this.state.showMatchDetails}
                toggleQuickTeamRegister={this.toggleQuickTeamRegister}
              />
            );

          case "Round Robin Groups":
            return (
              <DuelsRoundRobinMatches
                index={this.props.stageIndex}
                tournamentDetails={this.state.tournamentDetails}
                stageDetails={this.state.stageDetails}
                history={this.props.history}
                groupIndex={this.state.groupIndex}
                alterView={this.alterView}
                showMatchDetails={this.state.showMatchDetails}
                toggleQuickTeamRegister={this.toggleQuickTeamRegister}
              />
            );

          default:
            if (
              this.state.stageDetails.type === "DUEL" &&
              this.state.stageDetails.subType === "Bracket Groups" &&
              this.state.stageDetails.bracketType === "DOUBLE"
            ) {
              return (
                <DuelsDoubleBracketGroups
                  setGetAlertMethod={this.props.setGetAlertMethod}
                  index={this.props.stageIndex}
                  tournamentDetails={this.state.tournamentDetails}
                  stageDetails={this.state.stageDetails}
                  history={this.props.history}
                  groupIndex={this.state.groupIndex}
                  alterView={this.alterView}
                  showMatchDetails={this.state.showMatchDetails}
                  toggleQuickTeamRegister={this.toggleQuickTeamRegister}
                />
              );
            } else {
              return (
                <DuelsSingleBracketGroups
                  setGetAlertMethod={this.props.setGetAlertMethod}
                  index={this.props.stageIndex}
                  tournamentDetails={this.state.tournamentDetails}
                  stageDetails={this.state.stageDetails}
                  history={this.props.history}
                  groupIndex={this.state.groupIndex}
                  alterView={this.alterView}
                  showMatchDetails={this.state.showMatchDetails}
                  toggleQuickTeamRegister={this.toggleQuickTeamRegister}
                />
              );
            }
        }
      } else {
        switch (this.state.stageDetails.subType) {
          case "Single Elimination":
            return (
              <FFASingleEliminationMatches
                index={this.props.stageIndex}
                tournamentDetails={this.state.tournamentDetails}
                stageDetails={this.state.stageDetails}
                history={this.props.history}
                alterView={this.alterView}
                showMatchDetails={this.state.showMatchDetails}
                toggleQuickTeamRegister={this.toggleQuickTeamRegister}
              />
            );

          case "Simple Stage":
            return (
              <FFASimpleStageMatches
                index={this.props.stageIndex}
                tournamentDetails={this.state.tournamentDetails}
                stageDetails={this.state.stageDetails}
                history={this.props.history}
                alterView={this.alterView}
                showMatchDetails={this.state.showMatchDetails}
                toggleQuickTeamRegister={this.toggleQuickTeamRegister}
              />
            );

          case "FFA Bracket Groups":
            return (
              <FFABracketGroupMatches
                index={this.props.stageIndex}
                tournamentDetails={this.state.tournamentDetails}
                stageDetails={this.state.stageDetails}
                history={this.props.history}
                alterView={this.alterView}
                showMatchDetails={this.state.showMatchDetails}
                toggleQuickTeamRegister={this.toggleQuickTeamRegister}
              />
            );

          default:
            return (
              <FFAFlexibleStageMatches
                index={this.props.stageIndex}
                tournamentDetails={this.state.tournamentDetails}
                stageDetails={this.state.stageDetails}
                history={this.props.history}
                alterView={this.alterView}
                showMatchDetails={this.state.showMatchDetails}
                toggleQuickTeamRegister={this.toggleQuickTeamRegister}
              />
            );
        }
      }
    }
  };

  alterView = () => {
    this.setState({ showMatchDetails: !this.state.showMatchDetails });
  };

  render() {
    const { openQuickTeamRegister, openTeamInviteModal, teamInvitationData } = this.state;

    return (
      <>
        <section className="tournament-upcoming-matches text-white">
          <span className="d-flex ms-4">
            <img src={stages} className="" alt="" style={{ height: "20px", width: "16px" }} />
            <h1 className="fs-16 fw-700 ms-2">{this.state.stageDetails?.name}</h1>
          </span>

          <div className="container">
            {this.state.showMatchDetails ? <Scoreboard /> : this.getMatchesStructure()}
          </div>
        </section>
        <Modal centered show={openQuickTeamRegister} dialogClassName="register-clan-team-modal">
          <Modal.Body>
            <QuickTeamRegister
              onClanCreated={this.handleTeamCreated}
              toggleQuickTeamRegister={this.toggleQuickTeamRegister}
              tournamentDetails={this.state.tournamentDetails}
            />
          </Modal.Body>
        </Modal>

        {/* Team Invite Modal - shows after successful team creation */}
        <Modal centered show={openTeamInviteModal} dialogClassName="team-invite-modal">
          <Modal.Body>
            <TeamInviteModal
              invitationLink={teamInvitationData.invitationLink}
              teamName={teamInvitationData.teamName}
              teamId={teamInvitationData.teamId}
              clanId={teamInvitationData.clanId}
              onClose={() => this.toggleTeamInviteModal(false)}
            />
          </Modal.Body>
        </Modal>
      </>
    );
  }
}
